import {
  GetPolicyDraftResponseType,
  GetPolicyResponseType,
} from '@clearcover/core-app-types';

export type DraftIdentifier = {
  id: string;
  type: GetPolicyDraftResponseType['policyDraft']['draftType'];
};

export function findConflictingDraft(
  draftType: GetPolicyDraftResponseType['policyDraft']['draftType'],
  draftList: GetPolicyResponseType['draftList']
): DraftIdentifier | undefined {
  if (['renewal', 'renewal_quote'].includes(draftType)) {
    return draftList.find((draft) => draft.type === 'mid_term');
  }

  if (draftType === 'mid_term') {
    return draftList.find((draft) => draft.type === 'renewal_quote');
  }

  return undefined;
}
